import React from "react";
import PropTypes from "prop-types";
import { inlineElements, generateStyle, setOverLay, l } from "../../functions";

import { MyDraggable as Draggable } from "../../components/Core";
import HoverBar from "../../components/HoverBar";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Container, Row, Col } from "reactstrap";
import state from "../../state";
import { dummyProduct } from "../../consts/products";
import Icon from "../../components/Icons";

class ProductPictures extends React.Component {
  constructor(props) {
    super(props);
  }

  _initCarousel = () => {
    let { payload } = this.props;
    let { datas } = payload;

    if (payload === null) payload = this.props.options.payload;

    const { showThumbnails, thumbnailsPosition } = payload.datas || {
      showThumbnails: true,
      thumbnailsPosition: "bottom",
    };

    const cssSettings = generateStyle(payload, "container");

    return (
      <Container fluid={payload.fullContainer} style={cssSettings}>
        {setOverLay(payload)}
        <Row>
          <Col xs={12} className="fullcol">
            <div
              className={`product_pictures ${
                showThumbnails ? thumbnailsPosition : "bottom"
              }`}
            >
              <div className="main">
                <img src={dummyProduct.images[0]} />
              </div>
              {showThumbnails && (
                <div
                  className="thumbnail"
                  style={{
                    flexDirection: `${
                      thumbnailsPosition == "left" ||
                      thumbnailsPosition == "right"
                        ? "column"
                        : "row"
                    }`,
                  }}
                >
                  {dummyProduct.images.slice(0, 4).map((image, index) => (
                    <div key={index} className="item">
                      <img src={image} />
                    </div>
                  ))}
                </div>
              )}
              {!showThumbnails && (
                <div className="thumbnail-dots">
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
              )}
            </div>
          </Col>
        </Row>
      </Container>
    );
  };

  render() {
    const {
      dropzoneID,
      parentID,
      showBasicContent,
      showPreview,
      id,
      dropzoneProps,
      payload,
      options,
      ...rest
    } = this.props;

    if (showBasicContent) {
      const elements = state.getStorableState();
      let inDrop = false;

      if (Array.isArray(elements) && elements.length > 0) {
        const inlinedElements = inlineElements(elements);
        if (Array.isArray(inlinedElements) && inlinedElements.length > 0) {
          inlinedElements.forEach((element) => {
            if (element.type === this.props.type) inDrop = true;
          });
        } else inDrop = false;
      } else inDrop = false;

      return (
        <Draggable {...this.props} side={true}>
          <span className="dragger">
            {(Array.isArray(rest.icon) && (
              <FontAwesomeIcon icon={rest.icon} />
            )) || <Icon icon={rest.icon} />}
            <span>{l(rest.name)}</span>
            {(inDrop && <span className="added">{l("Added")}</span>) || (
              <span className="required">{l("Required")}</span>
            )}
          </span>
        </Draggable>
      );
    }

    if (showPreview) {
      return <div>{this._initCarousel()}</div>;
    }

    return (
      <Draggable {...this.props} minify={true}>
        <HoverBar
          datas={this.props}
          style={payload}
          parent={parentID}
          element={{ id, dropzoneID, parentID, payload }}
        />
        {this._initCarousel()}
      </Draggable>
    );
  }
}

ProductPictures.propTypes = {
  id: PropTypes.string.isRequired,
  showBasicContent: PropTypes.bool.isRequired,
};

export default ProductPictures;
